import { useCallback, useState } from "react";
import { Alert, Button, Inline, Stack } from "@leylion/design-system";
import { getRefundGiftCards } from "../api/client";
import type { GiftCard } from "../api/crm-types";
import { GiftCardCodeDialog } from "../crm/GiftCardCodeDialog";
import { valueError } from "../shared/value-copy";

export function RefundGiftCardPrintPanel({ orderId, refundId, settlementId, language }: {
  orderId: string; refundId?: string; settlementId?: string; language: "ar" | "en";
}) {
  const ar = language === "ar";
  const [cards, setCards] = useState<GiftCard[]>([]); const [selected, setSelected] = useState<GiftCard | null>(null);
  const [error, setError] = useState(""); const [busy, setBusy] = useState(false); const [loaded, setLoaded] = useState(false);
  const loadCode = useCallback(async (id: string) => {
    const rows = await getRefundGiftCards(orderId, { ...(refundId ? { refundId } : {}), ...(settlementId ? { settlementId } : {}) });
    const card = rows.find(item => item.id === id);
    if (!card) throw new Error(language === "ar" ? "البطاقة غير مرتبطة بهذا الاسترداد." : "This card does not belong to the refund.");
    return card;
  }, [orderId, refundId, settlementId, language]);
  const load = async () => { setBusy(true); setError(""); try {
    const rows = await getRefundGiftCards(orderId, { ...(refundId ? { refundId } : {}), ...(settlementId ? { settlementId } : {}) });
    setCards(rows); setLoaded(true); if (rows.length === 1) setSelected(rows[0]);
  } catch (e) { setError(valueError(e, language)); } finally { setBusy(false); } };
  return <Stack><Button data-testid="refund-gift-card-print" variant="secondary" disabled={busy} onClick={() => void load()}>{ar ? "طباعة / إعادة طباعة بطاقات الاسترداد" : "Print / reprint refund gift cards"}</Button>
    {error ? <Alert tone="danger" title={ar ? "تعذر تجهيز الطباعة؛ الاسترداد محفوظ" : "Print preparation failed; the refund is saved"}>{error}</Alert> : null}
    {loaded && !cards.length ? <small>{ar ? "لا توجد بطاقات بديلة لهذا الاسترداد." : "This refund has no replacement cards."}</small> : null}
    <Inline>{cards.map(card => <Button key={card.id} variant="secondary" onClick={() => setSelected(card)}>{card.giftCardNumber}</Button>)}</Inline>
    <GiftCardCodeDialog loadCode={loadCode} card={selected} language={language} onClose={() => setSelected(null)} />
  </Stack>;
}
